<template>
  <div id="aiFace">
    <div class="camera_outer">
      
      <div class="video">
        <div class="people-outline">
          <img src="../../assets/background/face.png">
        </div>
        <video ref="videoCamera" webkit-playsinline="true" playsinline="true" preload="metadata" x-webkit-airplay="deny"
          x5-video-player-type="h5" :width="videoWidth" :height="videoHeight" class="videoCamera" autoplay></video>
      </div>
      <canvas class="canvas" style="display: none" ref="canvasCamera" :width="videoWidth" :height="videoHeight">
      </canvas>
      <div class="action">
        <div>
            <van-button icon="replay" style="width:40px;height:40px;" round type="primary" @click="changeFacingMode"/>
        </div>
        <div v-if="isCheck" style="width:50%"> 
        <van-button round type="info" class="green" @click="submitBase64Img">确认</van-button>
        </div>
        <div v-else style="width:50%">
        <van-button @click="setImage" icon="photograph" round type="success" class="green" v-if="HkBaseFace==''">
         &nbsp;拍照
        </van-button>
        <van-button @click="reAction" icon="photograph" round type="success" class="green" v-else>
         &nbsp;重拍
        </van-button>
        </div>
 

      </div>
      <p style="color:red;font-size:13px;width: 70%;margin: 5px auto;">
        请保证面部清晰完整，不可以配戴口罩、墨镜（眼镜中有反光当作墨镜处理）。
      </p>
<!--       
      <div class="button-all">
        <van-button round type="default" @click="reAction">重拍</van-button>
        <van-button round type="info" @click="submitBase64Img">提交</van-button>
      </div> -->
  

   
    </div>

  </div>
</template>

<script>

import { Toast } from 'vant'
import { checkFace } from '@/api/admissionTicket'
// import { updateFitnessActivityList, selectWeightscore, getTermInfoList } from '../../services/fitnessAchievement'
import store from '@/store'
export default {
  name: 'camera',
  components: {  },
  data () {
    return {
      videoWidth: 290,
      videoHeight: 290,
      imgSrc: '',
      HkBaseFace: '',
      HrBaseFace: '',
      //             HkBaseFace  海康
      // HrBaseFace  虹软
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      openVideo: false,
      show: false,
      userInfo: {},
      percent: 0,
      faceCheckFlag: true,
      appeal: 0,
      appealShow: false,
      remindShow: false,
      appealContent: '',
      phoneNumber: '',
      termCode: '',
    //   { exact: 'user' }
      facingMode:'user',
      isCheck:false
    }
  },
  async created () {
    // this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    // await this.getSchoolTerm()
    // this.onDropChange(this.termCode)
  },

  mounted () {
    this.getCompetence() // 进入页面就调用摄像头
  },
  methods: {
    changeFacingMode(){
        if (this.facingMode == 'environment') {
        this.facingMode = 'user'
        }else if (this.facingMode == 'user') {
        this.facingMode = 'environment'
        }
        this.getCompetence()
    },
    reAction () {
      this.HkBaseFace = ''
      this.thisCancas.style.display = 'none'
      this.thisVideo.parentElement.style.display = 'block'
    },
    close () {
      this.$router.back()
    },
    submitBase64Img () {
    //   if (!this.HkBaseFace) {
    //     return Toast.fail('请先拍照')
    //   }
    const HkBaseFace = this.HkBaseFace.replace(/^data:image\/\w+;base64,/, '')
    let storeData = {...this.$store.faceInInfo}
    storeData.faceData = HkBaseFace
    store.commit('SER_FACE_IN_INFO', storeData)
    this.$router.back(-1)
    //   this.$dialog
    //     .alert({
    //       message: '确认提交?',
    //       showCancelButton: true
    //     })
    //     .then(() => {
    //       this.check()
    //     })
    //     .catch(() => {
    //       // on cancel
    //     })
    },

    check () {
      // const imgSrc = window.btoa(this.imgSrc);
      // const imgSrc = this.imgSrc.replace(/^data:image\/\w+;base64,/, '')
      const HkBaseFace = this.HkBaseFace.replace(/^data:image\/\w+;base64,/, '')
    //   const HrBaseFace = this.HrBaseFace.replace(/^data:image\/\w+;base64,/, '')
      checkFace({
        // snCode: this.userInfo.snCode,
        // baseFace: imgSrc,
        faceData:HkBaseFace,
        // hkBaseFace: HkBaseFace,
        // baseFace: HrBaseFace
      }).then(res=> {
        console.log(res);
            this.isCheck = true
        if (status === '00') {
        //   this.percent = percentage
        //   this.faceCheckFlag = faceCheckFlag
        //   this.show = true
        //   this.userInfo.faceStatus = faceStatus
        //   sessionStorage.setItem('userInfo', JSON.stringify(this.userInfo))
        }
      })
    },
    successFace () {
      this.$router.push({
        path: '/myFitness'
      })
    },
    // 调用权限（打开摄像头功能）
    getCompetence () {
      this.thisCancas = this.$refs.canvasCamera
      this.thisContext = this.thisCancas.getContext('2d')
      this.thisVideo = this.$refs.videoCamera
      this.thisVideo.style.display = 'block'
      // 获取媒体属性，旧版本浏览器可能不支持mediaDevices，我们首先设置一个空对象
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {}
      }
      // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
      // 使用getUserMedia，因为它会覆盖现有的属性。
      // 这里，如果缺少getUserMedia属性，就添加它。
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = (constraints) => {
          // 首先获取现存的getUserMedia(如果存在)
          const getUserMedia =
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.getUserMedia
          // 有些浏览器不支持，会返回错误信息
          // 保持接口一致
          if (!getUserMedia) {
            // 不存在则报错
            return Promise.reject(
              new Error('getUserMedia is not implemented in this browser')
            )
          }
          // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
          return new Promise((resolve, reject) => {
            getUserMedia.call(navigator, constraints, resolve, reject)
          })
        }
      }
      if (window.stream) {
        window.stream.getTracks().forEach(track => {
          track.stop()
        })
      }
      const constraints = {
        audio: false,
        video: {
          sourceId: 'default',
          facingMode:  { exact: this.facingMode },
          width: 300,
          height: 300
          // transform: "scaleX(-1)",
        }
      }
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          // 旧的浏览器可能没有srcObject
          this.thisVideo.srcObject = stream
          // if ('srcObject' in this.thisVideo) {
          //   this.thisVideo.srcObject = stream
          // } else {
          //   // 避免在新的浏览器中使用它，因为它正在被弃用。
          //   this.thisVideo.src = window.URL.createObjectURL(stream)
          // }
          this.thisVideo.play()
          // this.thisVideo.onloadedmetadata = (e) => {
          //   this.thisVideo.play()
          // }
        })
        .catch((err) => {
          console.log(err)
        })
    },

    //  绘制图片（拍照功能）
    setImage () {
      // canvas画图
      // canvas.toDataURL("image/jpeg", 0.8);
      this.thisContext.drawImage(this.thisVideo, 0, 0, 300, 300)
      // 获取图片base64链接
      const base64 = this.thisCancas.toDataURL('image/jpeg')
      const _this = this
      _this.compressImage(base64, 100, function (image) {
        // _this.imgSrc = image // 赋值并预览图片
        _this.HkBaseFace = image // 赋值并预览图片
        // 校验照片
        _this.check()
      })
      _this.compressImage(base64, 100, function (image) {
        _this.HrBaseFace = image // 赋值并预览图片
        _this.thisCancas.style.display = 'block'
        _this.thisVideo.parentElement.style.display = 'none'
      })
    },
    // 压缩图片
    compressImage (base64, targSize, callback) {
      const that = this
      if (base64.length / 1024 < targSize) {
        callback(base64)
        return
      }
      const newImage = new Image()
      newImage.src = base64
      newImage.setAttribute('crossOrigin', 'Anonymous') // url为外域时需要
      newImage.onload = function () {
        let quality = 0.95 // 压缩系数0-1之间
        const canvas = that.$refs.canvasCamera
        const videoCamera = that.$refs.videoCamera
        canvas.getContext('2d').drawImage(videoCamera, 0, 0)
        let base64 = canvas.toDataURL('image/jpeg', quality) // 压缩语句
        // 如想确保图片压缩到自己想要的尺寸,如要求在5-10kb之间，请加以下语句，quality初始值根据情况自定
        // console.log(base64.length + "循环1压缩" + (base64.length / 1024 > 512))

        while (base64.length / 1024 >= targSize) {
          quality -= 0.05
          // console.log(base64.length + "循环压缩" + quality)
          base64 = canvas.toDataURL('image/jpeg', quality)
        }
        callback(base64) // 必须通过回调函数返回，否则无法及时拿到该值
      }
    },

    // 关闭摄像头
    stopNavigator () {
      this.thisVideo.srcObject.getTracks()[0].stop()
    },

    // base64转文件，此处没用到
    dataURLtoFile (dataurl, filename) {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    onOversize () {
      Toast.fail('图片大小不能超过 30kb')
    },
    afterRead (file) {
      // 此时可以自行将文件上传至服务器
      console.log(file)
      this.thisContext.drawImage(this.thisVideo, 0, 0, 300, 300)
      this.imgSrc = file.content
      this.thisCancas.style.display = 'block'
      this.thisVideo.parentElement.style.display = 'none'
    },
    getSchoolTerm () {
      return new Promise((resolve) => {
        getTermInfoList().then(({ data }) => {
          this.list = data.map((item) => {
            return {
              text: item.name,
              value: item.code
            }
          })
          this.semesterInfo = data.filter((item) => item.isActive === '1')[0]
          this.termCode = this.semesterInfo.code
          resolve()
        })
      })
    },
    onDropChange (termCode) {
      selectWeightscore({
        fitnessAchievementActivity: {
          snCode: this.userInfo.snCode,
          termCode
        },
        type: 3
      }).then((data) => {
        this.appeal = data?.body?.status
      })
    },
    changeRemindShow () {
      if (+(this.appeal) === 0) {
        this.remindShow = true
      }
    },
    changeShow () {
      this.remindShow = false
      this.appealShow = true
      this.phoneNumber = ''
      this.appealContent = ''
    },
    forAppeal () {
      if (this.appealContent.length > 10) {
        updateFitnessActivityList({
          phoneNumber: this.phoneNumber,
          type: 3,
          fitnessAchievementActivity: {
            appealContent: this.appealContent,
            snCode: this.userInfo.snCode
          }
        }).then(({ status }) => {
          if (status === '00') {
            this.appealShow = false
            this.$router.go(-1)
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
#aiFace {
  padding: 0 0 40px;
  background: #f2f2f2;

  .title {
    font-size: 24px;
    color: #333333;
    font-weight: 700;
    text-align: center;
    padding: 40px 0;
  }

  .video {
    width: 70%;
    height: 290px;
    // background: url(../../assets/background/face.png) no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    position: relative;

    .videoCamera {
      margin: 0 auto;
      // border-radius: 50%;
    }
  }

  .people-outline {
    height: 290px;
    width: 130%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    // background: url(../../assets/background/face.png) no-repeat;
    background-repeat: no-repeat;
    background-size: contain;
  }
  .people-outline img{
    height: 100%;
    width: 100%;
  }
  .canvas {
    margin: 0 auto;
    // border: 1px solid #000;
    // background: url(../../assets/background/face.png) no-repeat;
    background-size: 100% 100%;
    // border-radius: 50%;
  }
 .green{
      width: 100%;
    }
  .action {

    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-top: 80px;
    // button .van-button {
    //   color: #fff;
    //   background-color: #32cb57;
    //   width: 70%;
    // }
    

    .uploader-btn {
      margin-top: 10px;
      padding-bottom: 3px;
      font-size: 12px;
      border-bottom: 1px solid #333333;
    }
  }

  .resetContent {
    width: 280px;
    min-height: 320px;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .percent {
      margin-top: 50px;
      font-size: 50px;
      font-weight: 700;
      color: #506df5;
    }

    .text {
      font-size: 16px;
      line-height: 28px;
      color: #1b4a6e;
      margin: 20px 0;
    }

    .reset {
      width: 60%;
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: #fff;
      font-size: 16px;
      font-weight: 600;
      // margin-left: 20%;
      background-color: #42caa5;
      border-radius: 30px;
      margin-top: 25px;
    }
  }

  .camera_outer {
    padding: 20px 0;

    /deep/ video {
      transform: rotateY(180deg);
    }

    .tips {
      text-align: center;
      padding: 0 20px 20px;
      width: 70%;
      margin: 0 auto;
    }
  }

  .img_bg_camera {
    padding: 20px 0;
    text-align: center;

    p {
      font-size: 14px;
      color: #333333;
      text-align: center;
    }
  }

  .tx_img {
    border-radius: 50%;
    width: 290px;
    height: 290px;
  }

  .button-all {
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
    position: fixed;
    bottom: 10%;
    width: 100%;
    z-index: 6;
  }
  .button-appeal{
    float: right;
    margin-right: 18vw;
    position: fixed;
    bottom: 5%;
    right: 0;
  }
  /deep/ .van-button--info,
  .van-button--default {
    width: 124px;
  }

  .van-popup {
    width: 78%;
    height: 250px;
    border-radius: 25px;
    box-sizing: border-box;

    .top {
      width: 100%;
      text-align: center;
      font-size: 17px;
      margin-top: 2.5%;
      margin-bottom: 2.5%;
    }

    .remind-info{
      padding: 20% 5%;
    }

    .popup-textarea {
      min-height: 90PX;
    }

    .bottom {
      margin-top: 20px;
      margin-left: 5%;

      div {
        display: inline-block;
        width: 45%;
        height: 40px;
        line-height: 40px;
        font-size: 18px;
        text-align: center;
        border-radius: 20px;
      }

      .cancel {
        color: #5471f5;
        background-color: #e7edf4;
      }

      .confirm {
        margin-left: 5%;
        color: #fff;
        background-color: #506df5;
      }
    }
  }
}
</style>
